import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';

// Página raiz `/` própria do Yggdrasil (o catálogo foi movido para `/catalog`
// no app-config). Registrada sob o pluginId 'app' — mesmo mecanismo dos
// módulos de theme/auth. noHeader: a HomePage desenha o próprio cabeçalho.
const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    title: 'Home',
    icon: <HomeIcon />,
    noHeader: true,
    loader: () => import('./HomePage').then(m => <m.HomePage />),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
